import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4801Model } from '../kymw4801.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * クロスコード取得サービス
 * @export GetCrossCodeService
 * @class GetCrossCodeService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCrossCodeService extends PlessJsonResponderSub<any> {
  private model: KYMW4801Model;
  private successFunc: Function;
  private exceptionErrorFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCrossCodeService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        PCode: this.vo.pCode,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4801Model} model モデルクラス
   * @param {any} vo 
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetCrossCodeService
   */
  execute(model: KYMW4801Model, vo: any, successFunc: Function, exceptionErrorFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.exceptionErrorFunc = exceptionErrorFunc;
    this.send('getCrossCode', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCrossCodeService
   */
  success(data: any): void {
    this.model.setCrossCodeData(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetCrossCodeService
   */
  exceptionError(status: string, result: any): void {
    this.exceptionErrorFunc(status, result);
  }
}
